"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LightBox;
exports.useClickOutside = useClickOutside;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _youtubePlayer = _interopRequireDefault(require("./youtube-player.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionMove = _interopRequireDefault(require("../../../experiments/animation/motion-move"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_MODAL_Z_INDEX = 108001;
const portalOverlay = "pl-p1kjr64x";
const LightboxOuter = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "LightboxOuter",
  class: "pl-lcbf8a1"
});
const LightboxInner = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "LightboxInner",
  class: "pl-lf12zlx"
});
const VideoInner = /*#__PURE__*/(0, _react2.styled)("video")({
  name: "VideoInner",
  class: "pl-vozwy8"
});
const CloseLightbox = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "CloseLightbox",
  class: "pl-c17y899a"
});

// TODO: Migrate this into base.functions and replace existing implementation
function useClickOutside(ref, handler, eventName = 'click', container = null) {
  _react.default.useEffect(() => {
    if (typeof document === 'undefined') return;
    const onClickEvent = evt => {
      if (ref.current && !ref.current.contains(evt.target)) handler(evt);
    };
    const target = container || document;
    target.addEventListener(eventName, onClickEvent);
    return () => target.removeEventListener(eventName, onClickEvent);
  }, [ref, handler, eventName, container]);
}

/**
 * VideoLightbox component.
 * @module LightBox
 *
 * @param {Object} props React props
 * @param {string} props.youTubeId Youtube ID for played video, will take preference over lightboxUrl.
 * @param {string} props.lightboxUrl Lightbox Video URL
 * @param {string} props.ariaLabelCloseButton Close Button aria label.
 * @param {Object} props.transcriptButton The link to video's transcript, an A11y requirement.
 * @param {boolean} [props.showModal=false] ShowModal Boolean
 * @param {function} props.handleClose Passing Close Button Function
 * @param {object} props.portalElem The node where LightBox should be rendered.
 * @param {string} props.dataCy data-cy attribute for testing
 * @param {string} props.dataCyYoutubePlayer data-cy attribute for youtube player
 * @param {boolean} props.disableAutoPlay Disable auto play for video and yt
 * @param {string} props.partial Partial name
 * @param {Array} props.lightboxCtas Array of ctas to be rendered in the lightbox
 * @returns {React.ReactElement} VideoLightbox component
 * @public
 */

function LightBox({
  showModal,
  handleClose,
  lightboxUrl,
  youTubeId,
  transcriptButton,
  ariaLabelCloseButton = 'Close Lightbox',
  portalElem,
  dataCy = 'video-player',
  dataCyYoutubePlayer,
  disableAutoPlay = false,
  partial,
  lightboxCtas
}) {
  const innerRef = (0, _react.useRef)(null);
  const shouldCloseOnEnd = !lightboxCtas;
  const handleVolume = e => {
    e.target.volume = 0.33;
  };
  const handleVideoEnd = () => {
    if (shouldCloseOnEnd) handleClose();
  };
  (0, _patternLibraryUtils.useExitOnEscape)(handleClose);
  useClickOutside(innerRef, handleClose, 'mousedown');
  const component = /*#__PURE__*/_react.default.createElement("section", {
    "data-cy": "light-box",
    className: portalElem ? portalOverlay : '',
    "data-partial": partial || 'light1'
  }, showModal && /*#__PURE__*/_react.default.createElement(LightboxOuter, {
    mode: "fluid",
    intensity: "200",
    variant: "appear"
  }, /*#__PURE__*/_react.default.createElement(LightboxInner, {
    mode: "swift",
    intensity: "300",
    variant: "moveUpFixed",
    ref: innerRef,
    delay: 0.2
  }, youTubeId ? /*#__PURE__*/_react.default.createElement(_youtubePlayer.default, {
    dataCy: dataCyYoutubePlayer,
    youTubeId: youTubeId,
    autoPlay: !disableAutoPlay,
    loading: "eager"
  }) : /*#__PURE__*/_react.default.createElement(VideoInner, {
    "data-cy": dataCy,
    preload: "auto",
    autoPlay: !disableAutoPlay,
    controls: true,
    onEnded: handleVideoEnd,
    onLoadStart: e => handleVolume(e)
  }, /*#__PURE__*/_react.default.createElement("source", {
    src: lightboxUrl,
    type: "video/mp4"
  })), transcriptButton && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, transcriptButton), lightboxCtas && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "cta-container",
    className: "cta-container"
  }, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: lightboxCtas?.map(cta => ({
      ...cta,
      shrinkOn: 'tabletLg'
    }))
  }))), /*#__PURE__*/_react.default.createElement(CloseLightbox, {
    onClick: handleClose,
    "aria-label": ariaLabelCloseButton,
    "data-cy": "close-lightbox"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "x"
  }))));
  return portalElem ? /*#__PURE__*/_reactDom.default.createPortal(component, portalElem) : component;
}
LightBox.propTypes = {
  youTubeId: _propTypes.default.string,
  ariaLabelCloseButton: _propTypes.default.string,
  lightboxUrl: _propTypes.default.string,
  showModal: _propTypes.default.bool,
  handleClose: _propTypes.default.func,
  portalElem: _propTypes.default.object,
  dataCy: _propTypes.default.string,
  dataCyYoutubePlayer: _propTypes.default.string,
  disableAutoPlay: _propTypes.default.bool,
  partial: _propTypes.default.string,
  transcriptButton: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  lightboxCtas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes))
};